export default function ProgressBar(props) {
  return (
    <div className="progress-bar">
      <div className="progress-indicator" style={{ width: `${props.percentage}%` }}></div>
    </div>
  );
}